import React, { useState } from 'react';
import classnames from 'classnames';
import {
  AppBar,
  Toolbar,
  IconButton,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import LogoImg from '../../images/logo-white.png';

import './Navbar.css';

const NavbarMenu = ({ scrollToSection }) => {

  return (
    <div className="Navbar__Menu__Container">
      <ul className="Navbar__Menu">
        <li>
          <div role="button" tabIndex={0} onKeyDown={() => scrollToSection('departments')} onClick={() => scrollToSection('departments')}>Departamentos</div>
        </li>
        <li>
          <div role="button" tabIndex={0} onKeyDown={() => scrollToSection('services')} onClick={() => scrollToSection('services')}>Servicios</div>
        </li>
        <li>
          <div role="button" tabIndex={0} onKeyDown={() => scrollToSection('contact')} onClick={() => scrollToSection('contact')}>Contacto</div>
        </li>
      </ul>
    </div>
  );
};

const Navbar = ({ scrollToSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const onSelectMenuOption = (section) => {
    onMenuToggle()
    scrollToSection(section)
  }

  const className = classnames('Navbar Navbar__Container', {
    'Navbar--open': isMenuOpen,
  });

  return (
    <React.Fragment>
      <AppBar className={className} position="fixed">
        <Toolbar className="Navbar__Toolbar">
          <div className="Navbar__Col" role="button" tabIndex={0} onKeyDown={() => scrollToSection('top')} onClick={() => scrollToSection('top')}>
            <div className="Navbar__Logo">
              <img src={LogoImg} width="100%" alt="logo ernestina village" />
            </div>
          </div>
          <div className="Navbar__Col">
            <IconButton className="Navbar__Menu__Button" onClick={onMenuToggle}>
              {!isMenuOpen && <MenuIcon />}
              {isMenuOpen && <CloseIcon />}
            </IconButton>
            <NavbarMenu scrollToSection={onSelectMenuOption} />
          </div>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </React.Fragment>
  );
};

export default Navbar;
